import { useCallback, useMemo } from 'react';

import { NotificationPreferenceEmailFrequency } from '@/types/schema';

import { NotificationPreferences_NotificationPreferenceFragment } from '../graphql/NotificationPreferences.generated';
import { usePreferenceUpdater } from './usePreferenceUpdater';

export function useNotificationPreferenceHandlers(
  prefs:
    | NotificationPreferences_NotificationPreferenceFragment
    | NotificationPreferences_NotificationPreferenceFragment[]
) {
  const preferences = useMemo(
    () => (Array.isArray(prefs) ? prefs : [prefs]),
    [prefs]
  );
  const { update, saving } = usePreferenceUpdater();

  const handleAppEnabledToggle = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const appEnabled = event.target.checked;
      preferences.forEach((preference) => {
        void update(preference, { appEnabled });
      });
    },
    [preferences, update]
  );

  const handleFrequencyChange = useCallback(
    (value: NotificationPreferenceEmailFrequency | 'none') => {
      preferences.forEach((preference) => {
        if (value === 'none') {
          void update(preference, {
            emailEnabled: false,
            emailFrequency: null,
          });
        } else {
          void update(preference, {
            emailEnabled: true,
            emailFrequency: value,
          });
        }
      });
    },
    [preferences, update]
  );

  return {
    handleAppEnabledToggle,
    handleFrequencyChange,
    saving,
  };
}
